/**
 *
 */
export default function getProcessEnv() {
  return process.env;
}